export default "__VITE_ASSET__BBpCW8Or__"